import { IFollowUpDonorForList } from '@nkr/models/index';
import { CenterGridWrapper } from '../../styles';
import { GridReadyEvent } from 'ag-grid-community';
import CommonList from './common-list';
import { DonorAction } from '../donor-action';

interface IProps {
    isAdminLogin: boolean,
    centerId: number,
    list: IFollowUpDonorForList[],
    isLoading: boolean,
    onLoadingComplete: () => void,
    onGridReady: (e: GridReadyEvent) => void,
    onItemSelected: (id: number, action: DonorAction) => void
}

const CenterSurveyList = (props: IProps) => {
    return (
        <CenterGridWrapper className='ag-theme-bootstrap' isSurveys={false}>
            <CommonList
                list={props.list}
                centerId={props.centerId}
                isAdmin={false}
                isAdminLogin={props.isAdminLogin}
                isLoading={props.isLoading}
                onLoadingComplete={props.onLoadingComplete}
                onGridReady={props.onGridReady}
                onItemSelected={props.onItemSelected}
            />
        </CenterGridWrapper>
    );
}

export default CenterSurveyList;